import { BorderRadius, Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const TrialStatusBannerWrapper = styled.div`
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.White};
`
